import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Admins from "./views/admins/Admins";
import AddNewAdmin from "./views/admins/AddNewAdmin";
import EditAdmin from "./views/admins/EditAdmins";
import Account from "./views/account/Account";

import Users from "./views/users/Users";
import EditUser from "./views/users/EditUser";
import AddNewUser from "./views/users/AddNewUser";
import UsersCameras from "./views/cameras/UsersCameras";
import AddCamera from "./views/cameras/AddCamera";
import Player from "./views/cameras/Player";
import EditCamera from "./views/cameras/EditCamera";
import NotProvisionedCameras from "./views/cameras/NotProvisionedCameras";
import DisabledCameras from "./views/cameras/DisabledCameras";


Vue.use(Router);

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "home",
            component: Home
        },
        {
            path: "/admins",
            name: "admins",
            component: Admins
        },
        {
            path: "/admins/add",
            name: "addNewAdmin",
            component: AddNewAdmin
        },
        {
            path: "/admins/get/:login",
            name: "editing-admins",
            component: EditAdmin
        },
        {
            path: "/account",
            name: "Account",
            component: Account
        },
        {
            path: "/users",
            name: "Users",
            component: Users
        },
        {
            path: "/users/get/:login",
            name: "editing-users",
            component: EditUser
        },
        {
            path: "/users/add",
            name: "add-users",
            component: AddNewUser
        },
        {
            path: "/cameras/get/:login/:type",
            name: "users-cameras",
            component: UsersCameras
        },
        {
            path: "/cameras/add/:login",
            name: "add-cameras",
            component: AddCamera
        },
        {
            path: "/cameras/video/:name",
            name: "player",
            component: Player
        },
        {
            path: "/cameras/edit/:login/:type/:name",
            name: "edit-camera",
            component: EditCamera
        },
        {
            path: "/not_provisioned_cameras",
            name: "not-provisioned-cameras",
            component: NotProvisionedCameras
        },
        {
            path: "/disabled_cameras",
            name: "disabled-cameras",
            component: DisabledCameras
        },

    ]
});
